export const environment = {
  appVersion: require('../../package.json').version,
  production: true,
  appInsights: {
    instrumentationKey: '4f265f1b-f9ae-4480-8be6-0b76e500f5d0'
  }
};
